module.exports = __webpack_public_path__ + "static/bc-08-f3d6c6dbb60508ff36a0fdfca4a101ba.jpg";